<template>
  <div>
    <div v-if="error" class="text-center">
      <br /><br />
      <h3 style="color: red">
        <v-icon style="color: red">mdi-alert-circle</v-icon>
        {{ error }}
      </h3>
      <br />
      <v-container>
        <v-row>
          <v-col class="ml-5 mr-5">
            <h3>
              <span class="orange--text text--darken-4">{{
                $t("footer.contact_undergraduate")
              }}</span>
            </h3>
            <v-divider color="#757575"></v-divider>
            <v-icon>mdi-phone</v-icon> : 0 2329 8163 {{ $t("footer.ext") }} 401
            - 404, 502<br />
            <v-icon>mdi-at</v-icon> : admission-reg@kmitl.ac.th<br />
            <v-icon>mdi-facebook</v-icon> :
            <a
              href="https://www.facebook.com/Admission.KMITL"
              target="blank"
              style="text-decoration: none"
              >admission.kmitl</a
            >
            <br />
            Fax : 02-329-8204
          </v-col>
          <v-col class="ml-5 mr-5">
            <h3>
              <span class="orange--text text--darken-4">{{
                $t("footer.contact_graduate")
              }}</span>
            </h3>
            <v-divider color="#757575"></v-divider>
            <v-icon>mdi-phone</v-icon> : 0 2329 8163 {{ $t("footer.ext") }} 101
            - 103, 503<br />
            <v-icon>mdi-at</v-icon> : grad-reg@kmitl.ac.th<br />
            <v-icon>mdi-facebook</v-icon> :
            <a
              href="https://www.facebook.com/reg.kmitl"
              target="blank"
              style="text-decoration: none"
              >reg.kmitl</a
            >
            <br />
            Fax : 02-329-8204
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div v-if="!error">
      <!--class="container" -->
      <br /><br />
      <p class="center">
        <button class="button" id="btPrint" @click="createPDF()">
          <span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <v-icon>mdi-printer</v-icon>&nbsp;&nbsp;Click
            พิมพ์ใบชำระเงิน&nbsp;</span
          >
        </button>
      </p>
      <br /><br />
      <div id="tab">
        <table class="center">
          <tr>
            <td width="15%" rowspan="3" align="center">
              <img src="kmitl_logo3.gif" />
            </td>
            <td colspan="3">
              <strong
                >สถาบันเทคโนโลยีพระจอมเกล้าเจ้าคุณทหารลาดกระบัง
                <span class="english-text"
                  >(King Mongkut's Institute of Technology Ladkrabang)</span
                ></strong
              >
            </td>
          </tr>
          <tr>
            <td colspan="3">
              สำนักทะเบียนและบริการการศึกษา
              <span class="english-text"
                >(KMITL Registration and Educational Service Office)</span
              >
            </td>
          </tr>
          <tr>
            <td colspan="1">
              ใบแจ้งการชำระเงินค่าสมัครสอบ <br />
              <span class="english-text">Pay in slip for application</span>
            </td>
            <td width="50%" colspan="2" align="left">
              วันที่&nbsp;&nbsp;{{ date_now_thai }} {{ dateObject }}<br /><span
                class="english-text"
                >Date&nbsp;&nbsp;{{ date_now_english }}</span
              >
            </td>
          </tr>
          <tr>
            <td colspan="2">
              สำหรับนักศึกษาระดับ{{ level_name_th }} (<span
                class="english-text"
                >{{ level_name_en }}</span
              >)
            </td>
            <td colspan="2" align="left">
              Ref. no.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ ref_1 }}
            </td>
          </tr>

          <tr>
            <td colspan="2" align="left">
              เลขที่สมัคร&nbsp;<span class="english-text"
                >(Registration No.)</span
              >&nbsp;&nbsp;{{ registId }}
            </td>
            <td colspan="2" align="left">
              ชื่อ – สกุล&nbsp;<span class="english-text">(Name-Surname)</span
              >&nbsp;&nbsp;{{ UserInfo_nameTh + " " + UserInfo_surnameTh }}
            </td>
          </tr>
          <tr>
            <td colspan="2" align="left">
              รอบ&nbsp;<span class="english-text">(Round)</span>&nbsp;&nbsp;{{
                round
              }}
            </td>
            <td colspan="2" align="left">
              โครงการ&nbsp;<span class="english-text">(Project)</span
              >&nbsp;&nbsp;{{ project }}
            </td>
          </tr>
          <tr>
            <td align="left" colspan="4">
              คณะ / วิทยาลัย / วิทยาเขต&nbsp;&nbsp;{{ facultyNameTh }} <br /><span
                class="english-text"
                >Faculty / College / Campus &nbsp;&nbsp;&nbsp;&nbsp;{{
                  facultyNameEn
                }}</span
              >
            </td>
          </tr>
          <tr>
            <td height="5"></td>
          </tr>
        </table>

        <!-- ตารางค่าจ่าย -->
        <table class="center cell">
          <tr>
            <td width="7%">
              ลำดับ
              <br />
              No.
            </td>
            <td width="73%">
              รายการ
              <br />
              Description
            </td>
            <td width="20%">
              จำนวนเงิน
              <br />
              Amount (Baht)
            </td>
          </tr>
          <tr>
            <td width="7%">1</td>
            <td align="left">
              ค่าสมัคร / Application fee
              <br />&nbsp;&nbsp;อันดับสาขาที่เลือกสมัคร / Number of curriculum
              selected to apply <br />&nbsp;&nbsp;&nbsp;&nbsp;
              <div v-for="(item, index) in register_curriculum" :key="index">
                &nbsp;&nbsp;&nbsp;&nbsp; {{ index + 1 }}
                {{ item.curriculum_name_th }} /
                <span class="english-text"> {{ item.curriculum_name_en }}</span>
                <br />
              </div>

              <br />

              <h6 class="notice-box1">
                ** หมายเหตุ **
                <font color="black"
                  >สแกน Barcode ด้วยแอปพลิเคชันเพื่อชำระเงิน หรือ
                  ชำระเงินผ่านเคาน์เตอร์ธนาคารที่ระบุเท่านั้น และ
                  โปรดตรวจสอบความถูกต้องของข้อมูล
                  <br />สามารถตรวจสอบข้อมูลการชำระเงินได้หลังจากชำระเงินแล้ว 3
                  วันทำการ
                </font>
                <br />*** โปรดเก็บใบรายการนี้ไว้ เพื่อเป็นหลักฐานการชำระเงิน ***
                <br /><span class="english-text">
                  <font color="red">**Remark** </font> You have to pay through
                  barcode or the specified bank counter only, please check the
                  accuracy of the payment information. <br />Please check your
                  payment status 3 days after having made the payment.
                  <br />
                  <font color="red"
                    >*** Please keep this slip as proof of payment. ***</font
                  >
                </span>
              </h6>
            </td>
            <td width="20%">{{ amount_add_comma }}</td>
          </tr>
        </table>

        <table class="center cell-total" border-top="none">
          <tr>
            <td align="left">
              <b>วันสุดท้ายของการชำระเงิน : </b>{{ endApplicationPayDate1 }} /
              &nbsp;<span class="english-text"
                >Payment due date : {{ endApplicationPayDate_english1 }}</span
              >
            </td>
            <td width="20%">ยอด <span class="english-text">(Total)</span></td>
            <td width="20%">{{ summary_add_comma }}</td>
          </tr>
          <tr>
            <td class="mini-font-left">
              วันที่รับฝาก <span class="english-text">(Deposit date)</span>
              <br /><b
                ><u
                  >หมายเหตุ <span class="english-text"> (Remark) </span>:
                </u></b
              >
              <div class="tab1">
                หากพ้นกำหนดนี้แล้วถือว่าการสมัครสอบเป็นโมฆะ <br /><span
                  class="english-text"
                  >(After the expiration of the specified period, the
                  application will be considered void.)</span
                >
              </div>
              <div class="tab1">
                ผู้สมัครจะต้องเสียค่าธรรมเนียมตามธนาคารกำหนด <br /><span
                  class="english-text"
                  >(Applicants have to pay the fees as specified by the
                  bank.)</span
                >
              </div>
            </td>
            <td class="mini-font-left" colspan="2">
              <br />&nbsp;สาขาผู้รับฝาก /<span class="english-text">
                Branch</span
              >
              <br /><br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ผู้รับเงิน
              /<span class="english-text"> Cashier</span>
              <br /><br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;สำหรับเจ้าหน้าที่ธนาคาร
              /<span class="english-text"> For bank officer</span>
            </td>
          </tr>
        </table>

        <div class="seperate-page">
          <br /><br />*** โปรดเก็บในรายการนี้ไว้ เพื่อเป็นหลักฐานการชำเงิน ***
          <span class="english-text">(For student)</span><br />
          ----------------------------------------------------------------------------------------
          <br />*** ส่วนของธนาคาร กรุณาเก็บค่าธรรมเนียมจากผู้ชำระเงิน ***<span
            class="english-text"
            >(For bank)</span
          ><br /><br />
        </div>

        <table class="center cell-total" border-top="none">
          <tr>
            <td align="left" width="60%">
              สถาบันเทคโนโลยีพระจอมเกล้าเจ้าคุณทหารลาดกระบัง
              <br />
              <div class="mini-font-left">
                King Mongkut's Institute of Technology Ladkrabang
              </div>
            </td>
            <td align="right">
              <div class="bigger-mini-font-right">
                ใบแจ้งชำระเงินเพื่อนำเข้าบัญชี
                <br />Payment of Student Account <br />รับเฉพาะเงินสด
                <span class="english-text">(Cash only)</span>
              </div>
              <div class="bigger-mini-font-left">
                <br />วันที่รับฝาก
                <span class="english-text">(Deposit date)</span>
              </div>
            </td>
          </tr>

          <tr class="mini-font-left">
            <td>
              <b>วันสุดท้ายของการชำระเงิน : </b>{{ endApplicationPayDate1 }} /
              &nbsp;<span class="english-text"
                >Payment due date: {{ endApplicationPayDate_english1 }}</span
              >
            </td>
            <td>Service Code :</td>
          </tr>

          <tr class="mini-font-left">
            <td>
              <b
                ><span id="bankAccount"
                  >{{ faculty_bank_account_scb }}&nbsp;&nbsp;
                  <img src="scb_new.jpg" width="20" /></span
                ><br />
              </b>
              <br />
              <!-- <span class="english-text"> {{ barcodeValue }}</span> -->
              <table class="center sub-table">
                <tr class="mini-font">
                  <td width="70%">
                    จำนวนเงินเป็นตัวอักษร/
                    <span class="english-text">Net paid (in words)</span>
                  </td>
                  <td>จำนวน/ <span class="english-text">Amount</span></td>
                </tr>
                <tr>
                  <td class="mini-font-left">
                    {{ applicationPayText }}-- <br />
                    <span class="english-text">{{
                      applicationPayText_english
                    }}</span>
                  </td>
                  <td class="mini-font">{{ summary_add_comma }}- บาท</td>
                </tr>
              </table>

              <br />
              ผู้สมัครจะต้องเสียค่าธรรมเนียมตามธนาคารกำหนด <br /><span
                class="english-text"
                >The net paid amount does not include bank charge.</span
              >
              <br />
            </td>
            <td>
              <span class="english-text">
                ชื่อ-สกุล (Name-Surname) :
                {{ UserInfo_nameTh + " " + UserInfo_surnameTh }}
              </span>
              <br /><b
                >รหัสการสมัคร (Ref1) : {{ ref_1 }} <br />รหัสการชำระเงิน (Ref2)
                : {{ ref_2 }}</b
              >
              <br /><span class="english-text">
                เบอร์โทรศัพท์ (tel,mobile) : {{ mobile }}
              </span>
              <br /><br />
              <table class="center sub-table">
                <tr>
                  <td class="mini-font">
                    ส่วนนี้สำหรับเจ้าหน้าที่ธนาคาร /<span class="english-text">
                      For bank</span
                    >
                  </td>
                </tr>
                <tr class="mini-font-left">
                  <td>
                    สาขาผู้รับฝาก /<span class="english-text"> Branch</span>
                    <br /><br />
                    ผู้รับเงิน /<span class="english-text"> Cashier</span>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>

        <br />
        <table class="center">
          <tr>
            <td>
              <img ref="my_barcode" style="width: 100%" />
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import authfoProvider from "@/services/auth.provider";
import CentralProvider from "@/services/central.provider";
import payInSlipProvider from "@/services/pay_in_slip.provider";

const authService = new authfoProvider();
const centralService = new CentralProvider();
const payInSlipService = new payInSlipProvider();
export default {
  name: "scbSlip",
  props: ["register_id"],
  data: () => ({
    error: null,
    UserInfo_nameTh: null,
    UserInfo_surnameTh: null,
    mobile: null,
    registId: null,
    ref_1: null,
    ref_2: null,
    project: null,
    endApplicationPayDate1: null,
    endApplicationPayDate_english1: null,
    round: null,
    // level: null,
    // year: null,
    level_name_th: null,
    level_name_en: null,
    facultyNameTh: null,
    facultyNameEn: null,
    register_curriculum: null,
    // order1: null,
    amount_add_comma: null,
    summary_add_comma: null,
    date_now_english: null,
    date_now_thai: null,
    applicationPayText: null,
    applicationPayText_english: null,
    barcodeValue: null,
    dateObject: null,

    a: [
      "",
      "one ",
      "two ",
      "three ",
      "four ",
      "five ",
      "six ",
      "seven ",
      "eight ",
      "nine ",
      "ten ",
      "eleven ",
      "twelve ",
      "thirteen ",
      "fourteen ",
      "fifteen ",
      "sixteen ",
      "seventeen ",
      "eighteen ",
      "nineteen ",
    ],
    b: [
      "",
      "",
      "twenty",
      "thirty",
      "forty",
      "fifty",
      "sixty",
      "seventy",
      "eighty",
      "ninety",
    ],
  }),
  components: {
    // barcode: VueBarcode,
  },
  methods: {
    async fetch_data() {
      await this.$store.dispatch("auth/getSidebarStatus");
      const uid = localStorage.getItem("uid");
      const data = await authService.getUserInfo(uid);
      this.UserInfo_nameTh = data.admission.STUDENT_FNAME_TH;
      this.UserInfo_surnameTh = data.admission.STUDENT_LNAME_TH;
      this.mobile = data.admission.MOBILE;
      //-------------------------- Get time from server ----------------------------------------

      const serverTime = await centralService.getServertime();

      const milliseconds = serverTime.timestamp * 1000;

      const dateObject = new Date(milliseconds);
      const date_year = dateObject.toLocaleString("th-TH", { year: "numeric" }); // 2019

      //-------------------------- Get  payment info ---------------------------------------------
      try {
        const uid = localStorage.getItem("uid");
        var dataApplication = await payInSlipService.getPaymentApplicationFee(
          parseInt(this.register_id),
          uid
        );
      } catch (err) {
        this.error = err.response.data.message;
      }
      this.registId = dataApplication.register_id;
      this.ref_1 = date_year.toString().substr(7, 2) + "01" + this.registId;
      this.ref_2 = dataApplication.ref_2;
      this.project = dataApplication.project_name_th;

      //---------------------------- Application last pay date -------------------------------------
      let payDate = new Date(dataApplication.end_application_pay_date);
      this.endApplicationPayDate1 = payDate.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      this.endApplicationPayDate_english1 = payDate.toLocaleDateString(
        "en-US",
        {
          year: "numeric",
          month: "short",
          day: "numeric",
        }
      );

      this.round = dataApplication.round_name_th;
      this.level = dataApplication.level_id;
      this.level_name_th = dataApplication.level_name_th;
      this.level_name_en = dataApplication.level_name_en;
      this.facultyNameTh =
        dataApplication.register_curriculum[0].faculty_name_th;
      this.facultyNameEn =
        dataApplication.register_curriculum[0].faculty_name_en;
      this.register_curriculum = dataApplication.register_curriculum;
      this.faculty_bank_account_scb =
        dataApplication.faculty_bank_account[1].bank_info_th;

      // this.order1 = dataApplication.order[1].description;
      this.summary_add_comma = dataApplication.summary
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.amount_add_comma = dataApplication.order[1].amount
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      // Date In B.E. for example 29 เมษายน 2564
      let date = new Date(milliseconds);
      this.date_now_thai = date.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      this.date_now_english = date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });

      let summary1 = dataApplication.summary;
      this.applicationPayText = this.getBahtText(summary1);
      this.applicationPayText_english = this.withDecimal(summary1);
    },

    createPDF() {
      var sTable = document.getElementById("tab").innerHTML;

      var style = "<style>";
      style =
        style +
        "@import url('https://fonts.googleapis.com/css2?family=Sarabun&display=swap');";
      style = style + "body{font-family: 'Sarabun', sans-serif;}";
      style = style + "ul {list-style-type: none; padding: 0;}";
      style = style + "li {display: inline-block; margin: 0 10px;}";
      style = style + "a {color: #42b983;}";
      style = style + "u {text-decoration: underline;}";
      style =
        style + "span1 {border-bottom:solid black 1px; padding-right:10rem;}";
      style = style + "table {width:100%;}";
      style =
        style +
        "table, th, td, tr {table-layout: fixed; overflow: hidden; padding: 2px 3px;}";
      style =
        style +
        "table.center {width:100%; margin-left : auto; margin-right : auto; font-size: 12px;}";
      style =
        style +
        ".cell {vertical-align : middle; text-align : center; width : 100%; border-collapse: collapse;";
      style =
        style + "border-top: double; border-top-width: 4px; font-size:12px;}";
      style =
        style + ".cell th {border:1px solid #C0C0C0; background:#F0F0F0;}";
      style =
        style +
        ".cell td {border:1px solid #C0C0C0; vertical-align:top; padding: 2px 4px;}";
      style =
        style +
        ".cell-total {vertical-align:middle; text-align:center; width:100%; ";
      style = style + "border-collapse:collapse; font-size:11px;}";
      style =
        style +
        ".cell-total th {border:1px solid #C0C0C0; background:#F0F0F0; font-size: 11px;}";
      style =
        style +
        ".cell-total td {border:1px solid #C0C0C0; vertical-align: top; ";
      style = style + "padding: 2px 4px; font-size: 11px;}";
      style =
        style +
        ".notice-box {padding: 10px 10px 10px 10px; outline-style: solid; outline-color: silver;";
      style =
        style + "outline-width: 1px; outline-offset: -10px; text-align: left;}";
      style = style + ".notice-box1 {text-align: center; color: red;}";
      style = style + ".tab1 {padding-left: 2em;}";
      style = style + ".mini-font-right {font-size: 11px; text-align: right;}";
      style = style + ".mini-font-left {font-size: 9px; text-align: left;}";
      style = style + ".mini-font {font-size: 11px; text-align: center;}";
      style = style + ".seperate-page {font-size: 8px; text-align: center;}";
      style =
        style + ".bigger-mini-font-right {font-size: 12px; text-align: right;}";
      style =
        style + ".bigger-mini-font-left {font-size: 12px; text-align: left;}";
      style = style + ".sub-table {width : 98%}";
      style =
        style +
        ".english-text {color: #696969; padding-top: -2em; font-size: 9px}";
      style = style + "</style>";

      // CREATE A WINDOW OBJECT.
      // var win = window.open('', '', 'height=700,width=700');
      var win = window.open("", "");

      win.document.write("<html><head>");
      win.document.write("<title>ใบรายการชำระเงินค่าสมัครสอบ สจล.</title>"); // <title> FOR PDF HEADER.
      win.document.write(style); // ADD STYLE INSIDE THE HEAD TAG.
      win.document.write("</head>");
      win.document.write("<body>");
      win.document.write(sTable); // THE TABLE CONTENTS INSIDE THE BODY TAG.
      win.document.write("</body></html>");

      // win.close(); // CLOSE THE CURRENT WINDOW.

      setTimeout(function () {
        win.print();
      }, 100); // PRINT THE CONTENTS.
    },
    // English Text money
    inWords(num) {
      if ((num = num.toString()).length > 9) return "overflow";
      let n = ("000000000" + num)
        .substr(-9)
        .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
      if (!n) return;
      let str = "";
      str +=
        n[1] != 0
          ? (this.a[Number(n[1])] || this.b[n[1][0]] + " " + this.a[n[1][1]]) +
            "million "
          : "";
      str +=
        n[2] != 0
          ? (this.a[Number(n[2])] || this.b[n[2][0]] + " " + this.a[n[2][1]]) +
            "hundred "
          : "";
      str +=
        n[3] != 0
          ? (this.a[Number(n[3])] || this.b[n[3][0]] + " " + this.a[n[3][1]]) +
            "thousand "
          : "";
      str +=
        n[4] != 0
          ? (this.a[Number(n[4])] || this.b[n[4][0]] + " " + this.a[n[4][1]]) +
            "hundred "
          : "";
      str +=
        n[5] != 0
          ? (str != "" ? "and " : "") +
            (this.a[Number(n[5])] || this.b[n[5][0]] + " " + this.a[n[5][1]]) +
            ""
          : "";
      return str;
    },
    withDecimal(n) {
      let nums = n.toString().split(".");
      let whole = this.inWords(nums[0]);
      if (nums[1] > 1) {
        let fraction = this.inWords(nums[1]);
        return whole + "point " + fraction + "Baht";
      } else {
        return whole + "Baht";
      }
    },
    // Thai text money
    getText(input) {
      let toNumber = input.toString();
      let numbers = toNumber.split("").reverse();

      let numberText = "/หนึ่ง/สอง/สาม/สี่/ห้า/หก/เจ็ด/แปด/เก้า/สิบ".split("/");
      let unitText = "/สิบ/ร้อย/พ้น/หมื่น/แสน/ล้าน".split("/");

      let output = "";
      for (let i = 0; i < numbers.length; i++) {
        let number = parseInt(numbers[i]);
        let text = numberText[number];
        let unit = unitText[i];
        if (number == 0) continue;
        if (i == 1 && number == 2) {
          output = "ยี่สิบ" + output;
          continue;
        }
        if (i == 1 && number == 1) {
          output = "สิบ" + output;
          continue;
        }
        output = text + unit + output;
      }
      return output;
    },
    getBahtText(inputNumber) {
      let fullNumber = Math.floor(inputNumber);
      let decimal = inputNumber - fullNumber;

      if (decimal == 0) {
        return this.getText(fullNumber) + "บาทถ้วน";
      } else {
        // convert decimal into full number, need only 2 digits
        decimal = decimal * 100;
        decimal = Math.round(decimal);

        return (
          this.getText(fullNumber) + "บาท" + this.getText(decimal) + "สตางค์"
        );
      }
    },
  },

  created() {
    this.fetch_data();
  },
};
</script>

<style scoped>
.svg-container {
  width: 80%;
}
body {
  width: 90%;
  margin: auto;
  font-family: "Sarabun", sans-serif;
  font-size: 15px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
u {
  text-decoration: underline;
}
/* p {
            border-bottom: solid white 1px;
        } */
.span1 {
  border-bottom: solid black 1px;
  padding-right: 5rem;
}

/* table */
table,
th,
td,
tr {
  table-layout: fixed;
  overflow: hidden;
}
table.center {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.cell {
  vertical-align: middle;
  text-align: center;
  width: 100%;
  border-collapse: collapse;
  border-top: double;
  border-top-width: 4px;
  font-size: 14px;
}
.cell th {
  border: 1px solid #c0c0c0;
  background: #f0f0f0;
}
.cell td {
  border: 1px solid #c0c0c0;
  vertical-align: top;
  padding: 2px 4px;
}

.cell-total {
  vertical-align: middle;
  text-align: center;
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.cell-total th {
  border: 1px solid #c0c0c0;
  background: #f0f0f0;
  font-size: 13px;
}
.cell-total td {
  border: 1px solid #c0c0c0;
  vertical-align: top;
  padding: 2px 4px;
  font-size: 13px;
}

.notice-box {
  padding: 10px 10px 10px 10px;
  outline-style: solid;
  outline-color: silver;
  outline-width: 1px;
  outline-offset: -10px;
  text-align: left;
}

.notice-box1 {
  text-align: center;
  color: red;
}

.tab1 {
  padding-left: 2em;
}

.mini-font-right {
  font-size: 13px;
  text-align: right;
}
.mini-font-left {
  font-size: 11px;
  text-align: left;
}
.mini-font {
  font-size: 13px;
  text-align: center;
}

.seperate-page {
  font-size: 10px;
  text-align: center;
}

.bigger-mini-font-right {
  font-size: 14px;
  text-align: right;
}
.bigger-mini-font-left {
  font-size: 14px;
  text-align: left;
}

.sub-table {
  width: 95%;
}

.english-text {
  color: #696969;
  padding-top: -2em;
}

.button {
  border-radius: 36px;
  background-color: #ff5722;
  border: none;
  color: #ffffff;
  text-align: center;
  font-size: 28px;
  padding: 15px;
  width: 100%;
  transition: all 0.3s;
  cursor: pointer;
}
.button span {
  cursor: pointer;
  display: inline-block;
  position: relative;
  transition: 0.3s;
}
.button span:after {
  content: "<< CLICK >>";
  font-size: 16px;
  position: relative;
  opacity: 0;
  top: 0;
  right: -20px;
  transition: 0.3s;
}
.button:hover span {
  padding-right: 100px;
}
.button:hover span:after {
  opacity: 1;
  right: 0;
}
</style>
